module.exports = __webpack_public_path__ + "img/Es-T600.b1deab38.gif";